import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { isAdminUser, isLoggedIn, isPremiumUser, isTrainerUser } from '../utils/user';
import { Filter1, Group, Public, HelpOutline, FitnessCenter, ContentPaste, DashboardCustomize } from '@mui/icons-material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import BuildIcon from '@mui/icons-material/Build';
import HistoryIcon from '@mui/icons-material/History';
import CategoryIcon from '@mui/icons-material/Category';
import TranslateIcon from '@mui/icons-material/Translate';
import { useContext } from 'react';
import { AppContext } from '@/contexts/app.context';
import { useNavigate } from 'react-router-dom';
import { pathMap } from './paths';

export const NavDrawer = (props: { open: boolean; setDrawerOpen: (open: boolean) => void }) => {
  const context = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <Drawer open={props.open} onClose={() => props.setDrawerOpen(false)}>
      <Box sx={{ width: 250, textAlign: 'center' }} role="presentation">
        <Typography sx={{ flexGrow: 1, fontFamily: 'Bungee Spice', mt: 2, ml: 1.5, mb: 1 }} variant="h5">
          Witness the Fitness Web UI
        </Typography>
        <Typography variant="caption">Version {process.env.REACT_APP_FRONTEND_VERSION}</Typography>
        <List>
          <ListItem key={'UserGuide'} disablePadding>
            <ListItemButton
              onClick={() => {
                navigate('/user-guide');
              }}
            >
              <ListItemIcon>
                <HelpOutline />
              </ListItemIcon>
              <ListItemText primary={'User Guide'} />
            </ListItemButton>
          </ListItem>
          {isLoggedIn() ? (
            <>
              <ListItem key={'All Exercises'} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate(pathMap.Exercises);
                  }}
                >
                  <ListItemIcon>
                    <Public />
                  </ListItemIcon>
                  <ListItemText primary={'All Exercises'} />
                </ListItemButton>
              </ListItem>

              <ListItem key={'Decks'} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate(pathMap.Decks);
                  }}
                >
                  <ListItemIcon>
                    <DashboardCustomize />
                  </ListItemIcon>
                  <ListItemText primary={'Decks'} />
                </ListItemButton>
              </ListItem>

              {
                <ListItem key={'Training History'} disablePadding>
                  <ListItemButton
                    onClick={() => {
                      navigate('/history');
                    }}
                  >
                    <ListItemIcon>
                      <HistoryIcon />
                    </ListItemIcon>
                    <ListItemText primary={'Training History'} />
                  </ListItemButton>
                </ListItem>
              }
              {!isAdminUser(context.state?.userProfile) ? (
                <ListItem key={'Support'} disablePadding>
                  <ListItemButton
                    onClick={() => {
                      navigate('/support');
                    }}
                  >
                    <ListItemIcon>
                      <HeadphonesIcon />
                    </ListItemIcon>
                    <ListItemText primary={'Support'} />
                  </ListItemButton>
                </ListItem>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
          <ListItem key={'Plans'} disablePadding>
            <ListItemButton
              onClick={() => {
                navigate('/plans');
              }}
            >
              <ListItemIcon>
                <ContentPaste />
              </ListItemIcon>
              <ListItemText primary={'Plans'} />
            </ListItemButton>
          </ListItem>

          {isTrainerUser(context.state?.userProfile) ? (
            <>
              <ListItem key={'Trainees'} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate('/trainees');
                  }}
                >
                  <ListItemIcon>
                    <AssignmentIndIcon />{' '}
                  </ListItemIcon>
                  <ListItemText primary={'Trainees'} />
                </ListItemButton>
              </ListItem>
            </>
          ) : (
            <></>
          )}

          {isLoggedIn() && (
            <ListItem key={'BodyZones'} disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate(pathMap.BodyZones);
                }}
              >
                <ListItemIcon>
                  <Filter1 />{' '}
                </ListItemIcon>
                <ListItemText primary={'Body Zones'} />
              </ListItemButton>
            </ListItem>
          )}

          {isAdminUser(context.state?.userProfile) ? (
            <>
              <ListItem key={'Exercise Categories'} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate(pathMap.ExerciseCategories);
                  }}
                >
                  <ListItemIcon>
                    <CategoryIcon />
                  </ListItemIcon>
                  <ListItemText primary={'Exercise Categories'} />
                </ListItemButton>
              </ListItem>
              <ListItem key={'Equipment'} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate('/equipment');
                  }}
                >
                  <ListItemIcon>
                    <FitnessCenter />
                  </ListItemIcon>
                  <ListItemText primary={'Equipment'} />
                </ListItemButton>
              </ListItem>
              <ListItem key={'Glossary'} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate('/glossary');
                  }}
                >
                  <ListItemIcon>
                    <TranslateIcon />
                  </ListItemIcon>
                  <ListItemText primary={'Glossary'} />
                </ListItemButton>
              </ListItem>
              <ListItem key={'Users'} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate('/users');
                  }}
                >
                  <ListItemIcon>
                    <Group />
                  </ListItemIcon>
                  <ListItemText primary={'Users'} />
                </ListItemButton>
              </ListItem>
              <ListItem key={'Maintenance'} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate('/maintenance');
                  }}
                >
                  <ListItemIcon>
                    <BuildIcon />
                  </ListItemIcon>
                  <ListItemText primary={'Maintenance'} />
                </ListItemButton>
              </ListItem>
            </>
          ) : (
            <></>
          )}
        </List>
      </Box>
    </Drawer>
  );
};
